import {ApiResponse, LvrCalculatorInput, LvrCalculatorValue} from "@portal-workspace/grow-shared-library";
import {Observable} from "rxjs";

export type GetLvrCalculatorValueFn =  (applicationId: number) => Observable<LvrCalculatorValue>;
export type UpdateLvrCalculatorValueFn = (applicationId: number, v: LvrCalculatorInput) => Observable<ApiResponse>;
